import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Contact from '../pages/contact/page';
import ServicesPage from '../pages/services/page';
import Gallery from '../pages/gallery/page';
import PaverDriveways from '../pages/services/paver-driveways/page';
import PaverPatios from '../pages/services/paver-patios/page';
import Walkways from '../pages/services/walkways/page';
import PoolDeck from '../pages/services/pool-deck/page';
import RetainingWalls from '../pages/services/retaining-walls/page';
import OutdoorLiving from '../pages/services/outdoor-living/page';
import HardscapeDesign from '../pages/services/hardscape-design/page';
import TampaPage from '../pages/locations/tampa/page';
import StPetersburgPage from '../pages/locations/st-petersburg/page';
import ClearwaterPage from '../pages/locations/clearwater/page';
import TarponSpringsPage from '../pages/locations/tarpon-springs/page';

const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/about', element: <About /> },
  { path: '/contact', element: <Contact /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/gallery', element: <Gallery /> },
  { path: '/services/paver-driveways', element: <PaverDriveways /> },
  { path: '/services/paver-patios', element: <PaverPatios /> },
  { path: '/services/walkways', element: <Walkways /> },
  { path: '/services/pool-deck', element: <PoolDeck /> },
  { path: '/services/retaining-walls', element: <RetainingWalls /> },
  { path: '/services/outdoor-living', element: <OutdoorLiving /> },
  { path: '/services/hardscape-design', element: <HardscapeDesign /> },
  { path: '/locations/tampa', element: <TampaPage /> },
  { path: '/locations/st-petersburg', element: <StPetersburgPage /> },
  { path: '/locations/clearwater', element: <ClearwaterPage /> },
  { path: '/locations/tarpon-springs', element: <TarponSpringsPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
